export const FETCH_REGION = 'regions/FETCH_REGION';
export const FETCH_PROVINCE = 'regions/FETCH_PROVINCE';
export const FETCH_COMMUNE = 'regions/FETCH_COMMUNE';
export const FETCH_COURT = 'regions/FETCH_COURT';
export const FETCH_RESOURCE = 'regions/FETCH_RESOURCE';
